import { useEffect } from 'react';
import useWindowSize from '../../store/window/resize';

export const useWindowResize = () => {
  const { setWindowSize, initializeWindowSize } = useWindowSize();

  useEffect(() => {
    // 초기 윈도우 크기 설정
    initializeWindowSize();

    const handleResize = () => {
      setWindowSize(window.innerWidth, window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [initializeWindowSize, setWindowSize]);

  return useWindowSize();
};
